module.exports = __webpack_public_path__ + "static/media/Katy W.3b48eb12.png";